import { Phone } from "lucide-react";
import { COMPANY } from "@/lib/constants";

export const StickyCallBar = () => (
  <a
    href={COMPANY.phoneHref}
    data-testid="sticky-call-bar"
    className="lg:hidden fixed bottom-0 inset-x-0 z-50 flex items-center justify-center gap-2 bg-primary text-primary-foreground h-16 text-lg font-semibold shadow-[0_-4px_20px_rgba(0,0,0,0.15)]"
  >
    <Phone className="w-5 h-5" />
    Call Now: {COMPANY.phone}
  </a>
);
